import { googleTagManager } from '@c15t/scripts/google-tag-manager';

type ConsentScript = ReturnType<typeof googleTagManager>;

/**
 * GTM via c15t: container loads as necessary (`alwaysLoad`) and fires tags
 * based on Consent Mode v2. Auth/preview params match former next/third-parties.
 */
export const buildGtmScript = (
  id: string,
  auth?: string,
  preview?: string,
): ConsentScript | null => {
  if (!id) return null;

  const script = googleTagManager({ id });
  const gtmAuth = auth ? `&gtm_auth=${auth}` : '';
  const gtmPreview = preview ? `&gtm_preview=${preview}&gtm_cookies_win=x` : '';

  return {
    ...script,
    id: `google-tag-manager-${id}`,
    src: `https://www.googletagmanager.com/gtm.js?id=${id}${gtmAuth}${gtmPreview}`,
  };
};
